module.exports = __webpack_public_path__ + "blilliant.36087d21.png";